// extracted by mini-css-extract-plugin
export default {"wrap":"JD-z","fullWidth":"KD-z","hideOnDesktop":"LD-z","content":"MD-z","hasOpenedNav":"ND-z","crumbsList":"OD-z","dropdownsWrap":"PD-z"};